import React, { useState } from 'react';
import './IntegrationSettings.scss';

import { fabric } from 'fabric';

import __ from './../utils/translation';

import { ReactComponent as IconSadSmiley } from './../icons/sad-smiley.svg';

let host = window.location.host;
let parts = host.split(".");
let subdomain = "";

if (parts.length >= 3) {
  subdomain = parts[0];
}

var baseURLEditor = 'https://'+ subdomain +'.aibizbox.co/';


const IntegrationSettings = ({ canvas }) => {

  const [search, setSearch] = useState('');
  const [imageType, setImageType] = useState('');
  const [items, setItems] = useState([]);

  // check if HTML5 File API is supported by the browser
  if (!window.File && !window.FileReader && !window.FileList && !window.Blob) {
    return (
      <div className="file-upload no-support">
        <p>{__(`Your browser doesn't support file upload. Please upgrade to a modern browser, for example:`)} <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">Chrome!</a></p>
        <p><IconSadSmiley /></p>
      </div>
    )
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value)
  }

  const handleImageTypeChange = (e) => {
    setImageType(e.target.value)
  }

  const submitQuery = async () => {
    if (search !== '' && imageType !== '') {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);
      let token = params.get('token')

    const formData = new FormData();
    formData.append('search', search);
    formData.append('type', imageType);
    formData.append('editor_version', token);

    fetch(baseURLEditor+'Editor/imageIntegration',
      {
        method: "POST",
        credentials: "include",
        body: formData
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }
      }).then(function (res) {
        if (res.status) {
          setItems(
              res.data
          );
        } 
      });
    }
  }

  const setCanvasImg = (url) => {
    if (url) {
      fabric.Image.fromURL(url, function (oImg) {
        oImg.set({ left: 35, top: 25 })
        canvas.add(oImg);
      }, { crossOrigin: 'Anonymous' });
    }
  }
  return (
    <>
      <p className="title">{__('Search Image')}</p>
      <div className="file-upload">
        <p>{__(`Here you can search image and add in canvas to create your own image`)}</p>
        <br />
        <div className="setting">
          <div className="label">{__('Search Keyword')}</div><div className="function">
            <input type="text" onChange={(e) => handleSearchChange(e)} className="search-input" placeholder="Search Image..." name="search" />
          </div>
        </div>
        <br />
        <div className="setting">
          <div className="label">{__('Platform')}</div><div className="function">
            <select onChange={(e) => handleImageTypeChange(e)} title="">
              <option value="">{__('Select Type')}</option>
              <option value="pixabay">{__('Pixabay')}</option>
              <option value="pixels">{__('Pixels')}</option>
              <option value="unsplash">{__('unsplash')}</option>
            </select>
          </div>
        </div>
        <div className="setting">
          <button type="button" onClick={() => submitQuery()}>Search</button>
        </div>
        <hr />

        <div>
          {items.map((v, k) => (
            <img src={v} width="100px" height="100px" alt="img" className="integration-images" onClick={() => setCanvasImg(v)} />
          ))}
        </div>
      </div>
    </>
  )

}


export default IntegrationSettings
